module.exports = __webpack_public_path__ + "static/fipcbrownleopardmain-9bc32f4692cec838ccd09ccedf99499b.jpeg";